<template>
<el-drawer :title="drawer.title" :visible.sync="drawer.visible" size="30%">
    <div class="drawer-form">
        <el-form :model="ruleForm" :rules="rules" ref="contractnomRuleForm" labelPosition="top" class="ruleForm" v-loading="loading">
            <el-form-item label="选择公司" prop="contract_no">
                <el-select v-model="ruleForm.company_id" clearable filterable class="select with100" placeholder="选择公司">
                    <el-option v-for="item in companyList" :key="item.id" :label="item.title" :value="item.id+ ''"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="订单号列表" prop="contract_no">
                <el-input type="textarea" v-model="ruleForm.contract_no"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="submitForm('contractnomRuleForm')">保存</el-button>
                <el-button @click="resetForm('contractnomRuleForm')">重置</el-button>
            </el-form-item>
        </el-form>
    </div>
</el-drawer>
</template>

<style lang="less">
@import url('@/assets/css/drawer.less');

.ruleForm {
    padding: 0 32px;
}
</style>

<script>
import dictionary from '@/utils/dictionary'
const ruleForm = {
    id: 0,
    company_id: '',
    contract_no: ''
}
export default {
    data() {
        return {
            drawer: {
                title: '',
                visible: false
            },
            ruleForm: Object.assign({}, ruleForm),
            rules: {
                contract_no: [{
                    required: true,
                    message: '请输入订单号',
                    trigger: 'blur'
                }]
            },
            loading: false
        };
    },
    beforeMount() {
        this.dictionary = dictionary;
    },
    computed: {
        companyList: function () {
            return dictionary.getPicker('company');
        },

    },
    methods: {
        showDrawer(options) {
            let that = this;
            if (options == '') {
                this.drawer.title = '添加订单号';
            } else {
                this.drawer.title = '编辑订单号';
            }
            this.drawer.visible = true;
            if (options != '') {
                let url = '/api/order.contract_no/read';
            } else {
                this.resetForm('contractnomRuleForm');
            }
        },
        submitForm(formName) {
            this.loading = true;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let that = this;
                    let url = '';
                    if (this.ruleForm.id == '') {
                        url = '/api/order.contract_no/create';
                    } else {
                        url = '/api/order.contract_no/save';
                    }

                    this.$post(url, this.ruleForm).then(function (response) {
                        if (response.code == '200') {
                            that.drawer.visible = false;
                            that.resetForm(formName);
                            that.$emit('getTableData');
                            that.$emit('showLog', response.data.batch_no);
                            that.loading = false;
                        } else {
                            that.$message(response.msg);
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.ruleForm = Object.assign({},ruleForm)
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        }
    }
};
</script>
